import * as React from 'react';
import {
    LineChart,
    Line,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
} from "recharts";

export function TransfergraphAnnually() {

    const AnnuallyBookingsData = [
        { year: 2023, bookings: 390 },
        { year: 2024, bookings: 1405 },
        { year: 2025, bookings: 2360 },
        { year: 2026, bookings: 2465 },
        { year: 2027, bookings: 890 },
        { year: 2028, bookings: 1200 },
        { year: 2029, bookings: 180 },
        { year: 2030, bookings: 1880 },
    ];

    return (
        <LineChart width={600} height={300} data={AnnuallyBookingsData}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="year" />
            <YAxis />
            <Tooltip />
            <Legend />
            <Line
                type="monotone"
                dataKey="bookings"
                stroke="#8884d8"
                activeDot={{ r: 8 }}
            />
        </LineChart>
    );
}


export function TransfergraphWeekly() {
    const AnnuallyBookingsData = [
        { month: "Jan", bookings: 390 },
        { month: "Feb", bookings: 1405 },
        { month: "Mar", bookings: 2360 },
        { month: "Apr", bookings: 2465 },
        { month: "May", bookings: 890 },
        { month: "Jun", bookings: 1200 },
        { month: "Jul", bookings: 180 },
        { month: "Aug", bookings: 1880 },
        { month: "Sept", bookings: 560 },
        { month: "Oct", bookings: 1380 },
        { month: "Nov", bookings: 1580 },
        { month: "Dec", bookings: 1480 },
    ];
    return (
        <LineChart width={600} height={300} data={AnnuallyBookingsData}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="month" />
        <YAxis />
        <Tooltip />
        <Legend />
        <Line
            type="monotone"
            dataKey="bookings"
            stroke="#8884d8"
            activeDot={{ r: 8 }}
        />
    </LineChart>
    );
}
export function TransfergraphMonthly() {
    const AnnuallyBookingsData = [
        { month: "Jan", bookings: 390 },
        { month: "Feb", bookings: 1405 },
        { month: "Mar", bookings: 2360 },
        { month: "Apr", bookings: 2465 },
        { month: "May", bookings: 890 },
        { month: "Jun", bookings: 1200 },
        { month: "Jul", bookings: 180 },
        { month: "Aug", bookings: 1880 },
        { month: "Sept", bookings: 560 },
        { month: "Oct", bookings: 1380 },
        { month: "Nov", bookings: 1580 },
        { month: "Dec", bookings: 1480 },
    ];
    return (
        <LineChart width={600} height={300} data={AnnuallyBookingsData}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="month" />
        <YAxis />
        <Tooltip />
        <Legend />
        <Line
            type="monotone"
            dataKey="bookings"
            stroke="#8884d8"
            activeDot={{ r: 8 }}
        />
    </LineChart>
    );
}





